import React from "react";

import { Truncated } from "~/components/truncated";
import { cx } from "~/tools/class-variance";

import type { MonitorCheckStatusRelatedFailuresCheckStatus } from "../../../../common/openapi";
import { Wrap } from "../../../../components/conditional-wrapper/Wrap";
import { HealthStateCircle } from "../../../../components/react/HealthCircle/HealthStateCircle";
import { InlineLink } from "../../../../components/react/styled/StyledComponents";
import { ViewTimeLink } from "../../../../components/react/viewtimelink/ViewTimeLink";

interface RelatedHealthViolationProps {
	item: MonitorCheckStatusRelatedFailuresCheckStatus;
	/**
	 * @default true
	 */
	showTriggeredTimestamp?: boolean;
	showAsLink?: boolean;
	onMessageClick: VoidFunction;
	className?: string;
}

export const RelatedHealthViolation: React.FC<React.PropsWithChildren<RelatedHealthViolationProps>> = ({
	item,
	showTriggeredTimestamp = true,
	showAsLink = true,
	children,
	onMessageClick,
	className,
}) => (
	<div className={cx("text-13/[21px]", className)} data-testid="related-health-violation">
		<div className="mb-px flex items-center gap-3">
			<HealthStateCircle size="small" state={item.health} />
			<Wrap
				if={showAsLink}
				with={(wrappedChildren) => (
					<InlineLink className="min-w-0" data-testid="monitor-status-link" onClick={onMessageClick}>
						{wrappedChildren}
					</InlineLink>
				)}
			>
				<Truncated>{item.name}</Truncated>
			</Wrap>
		</div>
		<div className="flex gap-1 text-gray-600">
			<div className={cx("flex gap-1", showTriggeredTimestamp ? "max-w-[calc(100%-140px)]" : "w-full")}>{children}</div>
			{showTriggeredTimestamp && <ViewTimeLink className="whitespace-nowrap" time={item.triggeredTimestamp} />}
		</div>
	</div>
);
